import React, { Component } from 'react';
import { Route, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { routes } from './services/employeePanel.routes';
import { menuItems } from './services/employeePanel.menuItems';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { CONTACT_INFO } from '../../services/constant/constant';

import logo from '../../assets/img/bsm-logo.png';
import logoSingle from '../../assets/img/bsm-logo-single.png';
import Header from '../../components/angle/Header';
import Sidebar from '../../components/angle/Sidebar';

import { logout } from '../../services/redux/authentication/actions';
import { updateSidebarSelectedItem } from '../../services/redux/employee/sidebar/actions';

class EmployeePanel extends Component {
    render() {
        const {
            history,
            user,
            roleName,
            logout,
            updateSidebarSelectedItem
        } = this.props;
        const animationName = 'rag-fadeIn';
        return !user ? (
            <Redirect
                to={{
                    pathname: '/login'
                }}
            />
        ) : (
            <div className="wrapper">
                <Header
                    logo={logo}
                    logoSingle={logoSingle}
                    showFullScreenButton
                    showLogOutButton
                    showUserButton
                    history={history}
                    logout={logout}
                    emailInfo={CONTACT_INFO.email}
                    callInfo={CONTACT_INFO.phone}
                    updateSidebar={updateSidebarSelectedItem}
                />
                <Sidebar
                    items={menuItems.filter(item =>
                        item.roles.includes(roleName)
                    )}
                />
                <ReactCSSTransitionGroup
                    component="section"
                    transitionName={animationName}
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={500}
                >
                    <div className="content-wrapper">
                        {routes.map((route, index) => {
                            return (
                                route.roles.includes(roleName) && (
                                    <Route
                                        exact
                                        key={index}
                                        path={route.path}
                                        component={route.component}
                                    />
                                )
                            );
                        })}
                    </div>
                </ReactCSSTransitionGroup>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    user: state.authentication.user,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            logout,
            updateSidebarSelectedItem
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EmployeePanel));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/index.js